/* global document */

import { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { getUrl } from 'common/helpers/miscHelper';
import { setLayout } from 'redux/layout/actions';
// eslint-disable-next-line import/no-cycle
import Widgets from 'widgets/Widgets';

import APIError from './components/APIError';

class Layout extends Component {
  UNSAFE_componentWillMount() {
    const c7Content = document.getElementById('c7-content');
    c7Content.removeAttribute('style');
    const c7CheckoutContent = document.getElementById('c7-checkout-content');
    if (c7CheckoutContent) {
      c7CheckoutContent.parentNode.removeChild(c7CheckoutContent);
    }
  }

  componentDidMount() {
    const { props } = this;
    if (!props.loading) {
      removeLoadingFromC7Content();
    } else {
      addLoadingFromC7Content();
    }
    if (props.apiError) {
      removeLoadingFromC7Content();
    }
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (!prevProps.apiError && props.apiError) {
      removeLoadingFromC7Content();
    }
    if (prevProps.loading && !props.loading) {
      removeLoadingFromC7Content();
    }
    if (!prevProps.loading && props.loading) {
      addLoadingFromC7Content();
    }
  }

  render() {
    const {
      title,
      showSideCart = true,
      children,
      settings,
      description
    } = this.props;
    if (!settings.data) {
      return (
        <section>
          <Helmet>
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
          </Helmet>
          <APIError position="layout" />
          {children}
          <div id="c7-modal" />
        </section>
      );
    }
    return (
      <section>
        <Helmet>
          <title>{title || getUrl(settings)}</title>
          {description && <meta name="description" content={description} />}
        </Helmet>
        <Widgets showSideCart={showSideCart} />
        <APIError position="layout" />
        {children}
        <div id="c7-modal" />
      </section>
    );
  }
}

const removeLoadingFromC7Content = () => {
  const c7Content = document.getElementById('c7-content');
  c7Content.style.minHeight = 0;
};

const addLoadingFromC7Content = () => {
  const c7Content = document.getElementById('c7-content');
  c7Content.style.minHeight = '100vh';
};

const mapStateToProps = (state) => ({
  apiError: state.apiError,
  settings: state.setting
});

export default connect(mapStateToProps, { setLayout })(Layout);
